module.exports = __webpack_public_path__ + "static/media/img-129.f92919ca.jpg";